export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00556.eb1a322b.png";